import { Business, Domain, Layers, AccountCircle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

export const InfoRow = ({ icon, label, value }: { icon: React.ReactNode, label: string, value: string }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        {/* <Box sx={{ mt: 0.5 }}>{icon}</Box> */}
        <Box>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, display: 'block', lineHeight: 1 }}>
                {label}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, color: '#333', mt: 0.5 }}>
                {value}
            </Typography>
        </Box>
    </Box>
);